// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=a7e38008-b0dd-4405-9b1a-291bdb12a541";
};